import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(public snackBar: MatSnackBar) { }

  handleError(message?: string) {
    this.snackBar.open(message || 'Error', 'dismiss', {
      duration: 3000,
    });
    return of('error handled');
  }

  handleSuccess(message?: string) {
    this.snackBar.open(message || 'Success', 'dismiss', {
      duration: 3000
    });
  }
}
